import React, { useState,useContext } from "react";
import { usePayafterDelivery } from "hooks/Forms/usePayafterDelivery";
import Loader from "components/loader";
import { useForm } from "react-hook-form";
import ThankYouPopup from "components/popup/thankYouPopup";
import DataProvider from "Context/DataContext";

function QuoteSingleForm({ setOpen  }) {

  const {
    LocalObject,
  } = useContext(DataProvider);

  const [thankOpen, setThankOpen] = useState(false);

  const { status, mutateAsync } = usePayafterDelivery();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
 
  const quote_id =
    LocalObject.localStorage !== undefined
      ? LocalObject.localStorage.getItem("quote_id")
      : "";


  const onSubmit = (data) => {
    const postData = {
      email: data.email,
      quote_id : quote_id
    };

    mutateAsync(postData).then((_) => {
      reset();
      setThankOpen(true);
    });
  };

  return (
    <div className="flex w-full md:px-6 px-2 items-center justify-between md:flex-nowrap flex-wrap md:mt-0 mt-6 rounded-md py-4 bg-white lg:py-8 lg:px-10 lg:gap-[50px]">
      <div className="md:mb-0 mb-6">
        <p className="text-lg sm:text-[22px] lg:text-[28px] text-darkBlue font-semibold font-secondary mb-2 text-center sm:text-left">
          Pay <span className="text-orange">after delivery</span>
        </p>
        <p className="text-sm sm:text-base text-darkBlue font-opensans text-center sm:text-left lg:pt-[5px]">
          No need to pay now. Just send your email or phone number and we'll get
          to work.
        </p>
      </div>
      <form
        className="flex  md:justify-center md:w-[unset] w-full justify-between"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex-col w-full md:w-[unset]">
          <div className="div w-full md:w-[unset]">
            <input
              type="text"
              className="h-[45px] rounded-tl-lg rounded-bl-lg text-quotetext-200 px-3 text-xs lg:text-14 lg:w-[280px] w-full border border-solid border-quotetext-100"
              placeholder="Enter your email / phone number"
              name="email"
              {...register("email", {
                required: true,
              })}
            />
          </div>
          <div>
            {errors.email && (
              <span className="text-red text-xs">This field is required</span>
            )}
          </div>
        </div>

        <button className="h-[45px] px-6 bg-darkBlue text-white rounded-tr-lg rounded-br-lg font-opensans font-bold">
          {status === "loading" ? <Loader /> : "SUBMIT"}
        </button>
      </form>
      <ThankYouPopup
        open={thankOpen}
        setOpen={setThankOpen}
        setOpenPopUp={setOpen}
      />
    </div>
  );
}

export default QuoteSingleForm;
